<template>
  <el-dialog
  :visible.sync="visible"
  title="预警管理"
  fullscreen
  :before-close="handleClose"
  >
   <earlyContainer :doctorId="doctorId" :hideTitle="true" :readOnly="true"/>
  </el-dialog>
</template>
<script>
import earlyContainer from "../earlyWarningM/early-container.vue";
export default {
  props: ["visible","doctorId"],
  components: {
    earlyContainer
  },
  data() {
    return {


    };
  },
  mounted(){


  },
  created() {

  },
  methods: {
    handleClose: function () {
      this.$emit('close');
    }
  },
};
</script>
<style lang="less" scoped="scoped">

</style>
